<template>
  <q-list v-if="authenticated">
    <q-item-label header>Menu</q-item-label>
    <q-item clickable to="/">
      <q-item-section avatar>
        <q-icon name="dashboard" />
      </q-item-section>
      <q-item-section>
        <q-item-label>Ana Sayfa</q-item-label>
      </q-item-section>
    </q-item>
    <q-item clickable to="/calendar">
      <q-item-section avatar>
        <q-icon name="calendar_today" />
      </q-item-section>
      <q-item-section>
        <q-item-label>Takvim</q-item-label>
      </q-item-section>
    </q-item>
    <q-item clickable to="/customers">
      <q-item-section avatar>
        <q-icon name="people" />
      </q-item-section>
      <q-item-section>
        <q-item-label>Danisanlar</q-item-label>
      </q-item-section>
    </q-item>
    <q-item clickable to="/subscription">
      <q-item-section avatar>
        <q-icon name="shopping_cart" />
      </q-item-section>
      <q-item-section>
        <q-item-label>Paketler</q-item-label>
      </q-item-section>
    </q-item>
    <q-item clickable to="/payments">
      <q-item-section avatar>
        <q-icon name="point_of_sale" />
      </q-item-section>
      <q-item-section>
        <q-item-label>Odemeler</q-item-label>
      </q-item-section>
    </q-item>
    <q-item clickable to="settings">
      <q-item-section avatar>
        <q-icon name="settings" />
      </q-item-section>
      <q-item-section>
        <q-item-label>Ayarlar</q-item-label>
      </q-item-section>
    </q-item>
    <q-item clickable to="logout">
      <q-item-section avatar>
        <q-icon name="logout" />
      </q-item-section>
      <q-item-section>
        <q-item-label>Cikis Yap</q-item-label>
      </q-item-section>
    </q-item>
  </q-list>
</template>
<script>
import { ref } from 'vue'
import * as auth from '../plugins/auth'
export default {
  setup() {
    const authenticated = ref(false)

    setInterval(() => {
      authenticated.value = auth.isAuthenticated()
    }, 1000)

    return {
      authenticated,
    }
  },
}
</script>
